export default __webpack_public_path__ + "static/media/Advanced Potion Making - BasedOn-10_01.4b48fb86.jpg";